import { DialogComponents } from "@Interfaces/Entities/Dialogs";
import { actions as dialogActions } from "@Store/Reducers/dialog";

/** Thank-you dialog shown when the participant finishes, before redirecting (Back returns here). */
export const openCompletionRedirectDialog = (redirectUrl: string) =>
    dialogActions.openDialog({
        id: DialogComponents.CompletionRedirectDialog,
        props: {
            redirectUrl,
            maxWidth: "xs",
            fullScreen: false,
            disableEscapeKeyDown: true,
        },
    });
